import emailjs from '@emailjs/browser';

// EmailJS configuration
const EMAILJS_SERVICE_ID = 'YOUR_SERVICE_ID'; // Replace with your EmailJS service ID
const EMAILJS_TEMPLATE_ID = 'YOUR_TEMPLATE_ID'; // Replace with your EmailJS template ID  
const EMAILJS_PUBLIC_KEY = 'YOUR_PUBLIC_KEY'; // Replace with your EmailJS public key

export interface WaitlistFormData {
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  organization: string;
  interest: string;
  farmSize: string;
  location: string;
  phone: string;
  message: string;
}

export const sendWaitlistEmail = async (formData: WaitlistFormData): Promise<boolean> => {
  try {
    // Initialize EmailJS (only needed once)
    emailjs.init(EMAILJS_PUBLIC_KEY);

    // Prepare template parameters
    const templateParams = {
      to_email: 'your-email@foodsply.com', // Replace with your email
      from_name: `${formData.firstName} ${formData.lastName}`,
      from_email: formData.email,
      phone: formData.phone || 'Not provided',
      role: formData.role,
      organization: formData.organization || 'Not provided',
      location: formData.location || 'Not provided',
      farm_size: formData.farmSize || 'Not applicable',
      interest: formData.interest,
      message: formData.message || 'No additional message',
      submission_date: new Date().toLocaleDateString(),
      submission_time: new Date().toLocaleTimeString(),
    };

    // Send email
    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams
    );

    console.log('Email sent successfully:', response);
    return true;
  } catch (error) {
    console.error('Failed to send email:', error);
    return false;
  }
};

// Alternative: Send to multiple recipients or create different email templates
export const sendWaitlistNotification = async (formData: WaitlistFormData): Promise<boolean> => {
  try {
    // You can create different templates for different purposes
    const adminTemplateParams = {
      to_email: 'admin@foodsply.com',
      subject: 'New Waitlist Signup',
      applicant_name: `${formData.firstName} ${formData.lastName}`,
      applicant_email: formData.email,
      applicant_role: formData.role,
      applicant_interest: formData.interest,
      full_details: JSON.stringify(formData, null, 2),
    };

    await emailjs.send(
      EMAILJS_SERVICE_ID,
      'admin_notification_template', // Different template for admin notifications
      adminTemplateParams
    );

    return true;
  } catch (error) {
    console.error('Failed to send admin notification:', error);
    return false;
  }
};